import React, { useState } from "react";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";
import { useProjectTaskDashboardContext } from "../context";
import { projectProductTaskListColumnsL } from "../responsiveData/product/gridColDefinitionL";
import { Divider, Typography } from "@mui/material";
import { DataGridDashboardWrapper } from "components/Wrappers/DataGrid/DataGridDashboardWrapper";

export const ProjectProductTaskListForDashboard = ({ pageName }) => {
  const { currentProjectProductList } = useProjectTaskDashboardContext();
  const [sortedRecords, setSortedRecords] = useState(currentProjectProductList);

  return (
    <>
      <ToolbarThinWrapper />
      <Typography>{pageName}</Typography>
      <Divider />
      <div style={{ width: "100%" }}>
        <DataGridDashboardWrapper
          getRowId={(options) => `${options.partLotId}`}
          rows={sortedRecords}
          getRowHeight={() => "auto"}
          disableColumnMenu={true}
          columns={projectProductTaskListColumnsL({
            records: currentProjectProductList,
            setOutputRecords: setSortedRecords,
            outputRecords: sortedRecords,
          })}
        />
      </div>
    </>
  );
};
